import { useEffect, useState } from "react";
import { getSMSQueue } from "../../api/api";
import { errorNotify } from "../../services/toast.notification";
import Table, { ColumnsType } from "antd/lib/table";
import Spinner from "../../components/_common/Spinner";
import { ConfigProvider } from "antd";
import { JalaliLocaleListener } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import { DatePicker as DatePickerJalali } from "antd-jalali";

export interface InputProps {
    url: any
  }

const SMSList = ({url}:InputProps) =>{

    const columns: ColumnsType<any> = [
        {title: 'پروفایل ',dataIndex: 'Str_ProfileName',key: 'Str_ProfileName'},
        {title: 'موبایل ',dataIndex: 'Str_MobileNumber',key: 'Str_MobileNumber'},
        {title: 'پذیرش ',dataIndex: 'Frk_AdmitID',key: 'Frk_AdmitID'},
        {title: 'اشتراک ',dataIndex: 'Frk_PatientInfo',key: 'Frk_PatientInfo'},
        {title: 'دکتر ',dataIndex: 'Frk_DoctorID',key: 'Frk_DoctorID'},
        {title: 'نوع پذیرش ',dataIndex: 'str_app',key: 'str_app'},
        {title: 'متن پیام ',dataIndex: 'Str_MessageText',key: 'Str_MessageText'},
        {title: 'صفحه ',dataIndex: 'Str_RequesterPage',key: 'Str_RequesterPage'},
        {title: 'کاربر ',dataIndex: 'Str_User',key: 'Str_User'},
        {title: 'زمان لاگ ',dataIndex: 'Str_LoggedDateTime',key: 'Str_LoggedDateTime'},       
    ];

    const [isLoading,setIsLoading] = useState(false);
    const [SMSQueue, setSMSQueue] = useState([]);
    const [firstDate,setFirstDate] = useState<any>(undefined);
    const [lastDate,setLastDate] = useState<any>(undefined);

    const loadSMS = (fromDate:any,toDate:any) => {

        const diff = toDate.diff(fromDate);
        const Difference_In_Days:any = diff / (1000 * 3600 * 24);
        if(Difference_In_Days>30)
           errorNotify("بازه زمانی نباید بیشتر از یک ماه باشد.");

        else{

        setIsLoading(true);
        getSMSQueue(url,fromDate.format('YYYY-MM-DD'),toDate.format('YYYY-MM-DD'))
        .then((result:any) => {

            let jsonResult = JSON.parse(result.data.json);
            //setUsers(jsonResult.listOfUser); 
            setSMSQueue(jsonResult.SMSQueue)
            console.log(jsonResult.SMSQueue);
            setIsLoading(false);            
        })
        .catch((error) => {
            setIsLoading(false);            

          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })
    }
  }

  const onChangeDatePicker = (dates:any,dateStrings:any,info:any) => {

    console.log(dates);
    if (!dateStrings) return;
    if (dateStrings.length < 2) return;
    if (dateStrings[0] === "") return;
    if (dateStrings[1] === "") return;

    setFirstDate(dates[0])
    setLastDate(dates[1]);

    loadSMS(dates[0],dates[1]);
}

  useEffect(()=>
  {
    
  },[]);

  return(
    <>

    <center style={{paddingTop:'15px'}}> 
        <div className="calender" >
            <ConfigProvider locale={fa_IR} direction="rtl">
                <JalaliLocaleListener />
                <DatePickerJalali.RangePicker value={[firstDate,lastDate]}  onCalendarChange={(dates:any,dateStrings:any,info:any)=>onChangeDatePicker(dates,dateStrings,info)} />
            </ConfigProvider>
        </div>
    </center>

    {
        isLoading === false &&(
        <>
            <div className="inner-tabs_content">               
                <Table scroll={{x:"max-content"}} dataSource={SMSQueue} columns={columns} 
                rowClassName={(record) => (record.Frk_State === 0 ? "gray-back" : record.Frk_State === 1 ? "green-back":"red-back")}
                />                                   
        </div>
        </> 
        )
    }
   
    {
      isLoading === true  && (
      <Spinner />
    )
    }
    </>  
      
    )
}

export default SMSList;